import React, { useState } from 'react'
import { Box, Grid2 } from '@mui/material'
import { useStudentList } from '../../assets/api/UseStudentGetApi'
import { Field } from 'formik'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useStudentColumnwithDialog } from '../../shared/utils/useStudentColumnwithDialog'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'

const StudentsList = () => {
  const { studentColumns, dialogJSX } = useStudentColumnwithDialog();
  const [filters, setFilters] = useState({});
  const { data: studentlist, isLoading } = useStudentList(filters);
  const uniqueApartmentOptions = Array.from(
    new Map(
      (studentlist?.data ?? [])
        .filter(item => item?.apartment_name)
        .map(item => [item.apartment_name, item])
    ).values()
  ).map(item => ({
    id: item.apartment_id,
    label: item.apartment_name,
    value: item.apartment_name,
  }));

  const uniqueCourseOptions = Array.from(
    new Map(
      (studentlist?.data ?? [])
        .filter(item => item?.title)
        .map(item => [item.title, item])
    ).values()
  ).map(item => ({
    id: item.course_id,
    label: item.title,
    value: item.title,
  }));

  return (
    <Box>
      <TableFilterTemplate
        title="Student List"
        columns={studentColumns}
        rowsData={studentlist?.data || []}
        isLoading={isLoading}
        filterInitialValues={filters}
        filterReset={() => setFilters({})}
        onApplyFilters={(f) => setFilters(f)}
        renderFilterFields={() => (
          <>
            <Grid2 children size={12}>
              <Field
                name="apartment_id"
                component={IdAutoCompleteField}
                options={uniqueApartmentOptions}
                label="Select Apartent"
                isRequired={true}
                isLoading={isLoading}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="course_id"
                component={IdAutoCompleteField}
                options={uniqueCourseOptions}
                label="Select Course"
                isRequired={true}
                isLoading={isLoading}
              />

            </Grid2>
          </>
        )}
      />
      {dialogJSX}

    </Box>
  )
}

export default StudentsList